import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CardActions from '@mui/material/CardActions';
import DoubleArrowSharpIcon from '@mui/icons-material/DoubleArrowSharp';
import Button from '@mui/material/Button';
import { Grid, Typography, Link, Chip } from '@mui/material';

const eventStatusText = (eventStatus, membersOnly) => {
  if (membersOnly) {
    return 'Become a member';
  } else if (eventStatus === 'upcoming') {
    return 'Register';
  } else if (eventStatus === 'completed') {
    return 'See how it went';
  }
};

const eventStatusChip = (eventStatus) => {
  if (eventStatus === 'upcoming') {
    return <Chip label='Upcoming' color='secondary' />;
  } else if (eventStatus === 'completed') {
    return <Chip label='Completed' color='primary' />;
  }
};

const membersOnlyChip = (membersOnly) => {
  if (membersOnly) {
    return <Chip label='Members Only' color='primary' sx={{ ml: '0.5rem' }} />;
  }
};

const EventCard = (props) => {
  return (
    <Grid
      item
      component={Card}
      xs={12}
      md={2.8}
      sx={{
        position: 'relative',
        margin: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        transition: 'transform 0.2s ease-in-out',
        '&:hover': { transform: 'scale3d(1.03, 1.03, 1)', zIndex: 1 },
      }}>
      <Link
        href={props.membersOnly ? 'https://the100club.io/payments' : props.eventLink}
        sx={{ textDecoration: 'none' }}
        target='_blank'>
        <CardContent>
          <CardMedia sx={{ padding: 0 }}>
            <img
              src={`https://hnjiwdxlyyttjbocwpfw.supabase.co/storage/v1/object/public/events/${props.eventImage}`}
              alt={`${props.eventImage}`}
            />
          </CardMedia>
        </CardContent>
        <CardContent>
          {eventStatusChip(props.eventStatus)}
          {membersOnlyChip(props.membersOnly)}
        </CardContent>
        <CardContent>
          <Typography variant='p'>
            {new Date(props.eventDate).toLocaleString('en-us', { day: 'numeric', month: 'short', year: 'numeric' })}
          </Typography>
        </CardContent>
        <CardActions>
          <Button size='small' endIcon={<DoubleArrowSharpIcon />}>
            {eventStatusText(props.eventStatus, props.membersOnly)}
          </Button>
        </CardActions>
      </Link>
    </Grid>
  );
};

export default EventCard;
